@if (hasStock) {
  <div class="stock-badges">
    @for (stockBadge of stockBadges; track stockBadge.type) {
      <span class="stock-badge" [class]="stockBadge.type">
        <em class="stock-badge__icon"></em>
        <span class="stock-badge__label">{{ stockBadge.label }}</span>
        <span class="stock-badge__value">{{ stockBadge.value | number }} pcs</span>
      </span>
    }
  </div>
}
